
import './App.css';
import { Navbarmenu } from './Components/Navbar/Navbarmenu';
import { TopNavbar } from './Components/Navbar/TopNavbar';
import { Bfooter } from './Components/Footer/Bfooter';
import{ Copyrfooter } from './Components/Footer/Copyrfooter';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import{Latestupdate} from './Components/Maincontent/Latestupdate';
import { Login } from './pages/Login';
import { Ourclient } from './pages/Ourclient';
import { Contactus } from './pages/Contactus';
import { Ourproduct } from './Components/Maincontent/Ourproduct'
import { Offers } from './pages/Offers';
import { Ourfeature } from './Components/Maincontent/Ourfeature';
import { Page404 } from './pages/Page404';
// import { Home } from './pages/Home';




function App() {
  return (
    <div>
      {/* <TopNavbar/> */}
      <BrowserRouter>
      <Navbarmenu/>
          <Routes>
          <Route path="/"
           element={
              <>
                <Latestupdate />
                <Ourproduct />
                {/* <Ourfeature /> */}
                {/* <Offers /> */}
              
                <Contactus />
                {/* <Ourclient /> */}
               {/* <Home>
                   <Itemcategory Category="cement" />
                  <Itemcategory Category="Tiles" />
                  <Itemcategory Category="Granite" />
                  <About /> 
                </Home> */}
              </>
            } />
            {/* Category Routes */} 
          {/* <Route path="/Cement" element={<Itemcategory Category="cement" />} />
          <Route path="/Tiles" element={<Itemcategory Category="Tiles" />} />
          <Route path="/Granite" element={<Itemcategory Category="Granite" />} /> */}
          {/* <Route path="/:category" element={<ItemcategoryWrapper />} /> */}


            {/* Static Page Routes */}
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<Register />} /> 
          <Route path="/cart" element={<Cart />} />
          <Route path="/about" element={<About />} />*/}

           {/* 404 Page Route */}
           <Route path="*" element={<Page404 />} />
           

            </Routes>
           {/* <Latestupdate/>
          <Ourfeature/>
          <Offers/>
          <Ourproduct/>
          <Contactus/>
          <Ourclient/>
         <Login/> 
         <Page404/>   */}
              <Bfooter />
        <Copyrfooter />
      </BrowserRouter>
    </div>
  );
}

export default App;
